import AttendanceEntry from "./attendanceEntry";
import AttendanceReportDetails from "./attendanceReport/attendanceReportDetails";
import ClassFeePendings from "./classFeePendings";
import Dashboard from "./dashboard";
import GeneralAtttendanceEntry from "./generalAtttendanceEntry";
import MarkedAttendanceReport from "./markedAttendanceReport";
import MyProfile from "./myProfile";
import MyTimetable from "./myTimetable";
import Notification from "./notification";
import NotificationDetails from "./notification/notificationDetails";
import LeaveList from "./leaveList";
import InternalCircularView from "./collegeCircular/internalCircularVIew";
import ExternalCircularView from "./collegeCircular/externalCircularVIew";
import CollegeCircular from "./collegeCircular";
import LibraryList from "./libraryList";
import PendingAttendanceList from "./pendingAttendanceList";
import Events from "./events";
import Circular from "./circular";
import CircularDetails from "./circular/circularDetails";
import Permission from "./permission";
import OdPermission from "./odpermission";
import MarkedHostelAttendanceReport from "./markedHostelAttendanceReport";
import HostelAttendance from "./hostelAttendance";
import StaffAttendance from "./staffAttendance";
import ServiceOrganizationAttendance from "./serviceorganizationAttendance";
import StudentSearch from "./studentSearch/studentSearch";
import TaskManagement from "./taskManagement";
import ClassMonitoring from "./classMonitoring";
import Establishment from "./establishment";
import StaffProfile from "./staffprofile";
import PaySlip from "./paySlip";

export default [
  {
    path: "/",
    element: Dashboard,
    title: "Dashboard",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/attendance-entry",
    element: AttendanceEntry,
    title: "Attendance Entry",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/custom-attendance-entry/:special?",
    element: GeneralAtttendanceEntry,
    title: "Attendance Entry",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/my-timetable",
    element: MyTimetable,
    title: "My Timetable",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/myprofile",
    element: MyProfile,
    title: "My Profile",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/events",
    element: Events,
    title: "Events",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/permission",
    element: Permission,
    title: "My Permission",
    module: "mob_staff_allow_permission",
    action: "action_create",
    exact: true,
  },
  {
    path: "/odpermission",
    element: OdPermission,
    title: "My Permission",
    module: "mob_staff_allow_odpermission",
    action: "action_create",
    exact: true,
  },

  {
    path: "/my-att-report/:type?",
    element: MarkedAttendanceReport,
    title: "My Attendance Report",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/att-report-details",
    element: AttendanceReportDetails,
    title: "Attendance Report Details",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/atttendance-pending-list",
    element: PendingAttendanceList,
    title: "Pending Attendance List",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/fee-pending-list",
    element: ClassFeePendings,
    title: "Class Fee Pendings",
    module: "mob_staff_view_class_pending",
    action: "action_list",
    exact: true,
  },
  {
    path: "/notification",
    element: Notification,
    title: "Notification",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/notification/read/:id",
    element: NotificationDetails,
    title: "Notification",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/circular",
    element: Circular,
    title: "Circular",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/circular/read/:id",
    element: CircularDetails,
    title: "Circular",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/myleaves",
    element: LeaveList,
    title: "Leave List",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/internal-college-circular/:id",
    element: InternalCircularView,
    title: "Leave List",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/external-college-circular/:id",
    element: ExternalCircularView,
    title: "Leave List",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/collegecircular",
    element: CollegeCircular,
    title: "College Circular List",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/library",
    element: LibraryList,
    title: "Library",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/hostel-attendance",
    element: HostelAttendance,
    title: "Hostel Attendance",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/staff-attendance",
    element: StaffAttendance,
    title: "Staff Attendance",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/serviceorganization-attendance",
    element: ServiceOrganizationAttendance,
    title: "Service Organization Attendance",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/hostel-att-report",
    element: MarkedHostelAttendanceReport,
    title: "Hostel Attendance",
    module: "any",
    action: "any",
    exact: true,
  },
  // {
  //   path: "/staffprofile",
  //   element: StaffProfile,
  //   title: "Staff Profile",
  //   module: "mob_staff_profile",
  //   action: "action_create",
  //   exact: true,
  // },
  {
    path: "/staffprofile",
    element: StaffProfile,
    title: "Staff Profile",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/student-search",
    element: StudentSearch,
    title: "Student Search",
    module: "mob_student_profile_view",
    action: "action_list",
    //module: "any",
    // action: "any",
  },

  {
    path: "/task-management",
    element: TaskManagement,
    title: "Task Management",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/class-monitoring",
    element: ClassMonitoring,
    title: "Class Monitoring",
    module: "any",
    action: "any",
    exact: true,
  },

  {
    path: "/establishment",
    element: Establishment,
    title: "Establishment",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/payslip",
    element: PaySlip,
    title: "Pay Slip",
    module: "any",
    action: "any",
    exact: true,
  },
];
